import { Dashboard, Home } from "@material-ui/icons"
import GroupIcon from "@material-ui/icons/Group"

export const getEmpresaSections = () => [
  {
    id: "empresa",
    items: [
      {
        id: "dashboard",
        title: "Dashboard",
        icon: Dashboard,
        href: "/empresa/dashboard",
      },
      {
        id: "conjuntos",
        title: "Conjuntos",
        icon: Home,
        href: "/empresa/conjuntos",
      },
      {
        id: "administracion",
        title: "Administración",
        icon: GroupIcon,
        href: "/empresa/administracion",
      },
    ],
  },
]
